module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Media/Media-library#3-d9e9c379e424873dcb6b52849f885cf2.svg";